import React from "react";
import { Reveal, Section, Container, EyebrowLarge } from "./Shared";
import { TrendingUp, Heart } from "lucide-react";


const aboutImage = require("../../assets/ivani/au.jpg");

export default function AboutUs() {
    return (
        <Section id="about" className="relative font-body py-32">
            {/* Ambient Background Glows */}
            <div className="absolute top-40 right-0 w-[600px] h-[600px] rounded-full blur-[120px] pointer-events-none opacity-20" style={{ background: 'var(--ivani-color)' }} />
            <div className="absolute bottom-0 left-0 w-[500px] h-[500px] rounded-full blur-[100px] pointer-events-none opacity-10" style={{ background: 'var(--ivani-color)' }} />

            <Container>
                {/* <Reveal> */}
                <div className="text-center mb-10 md:mb-10">
                    <span className="inline-block py-1 px-3 rounded-full bg-white/5 border border-white/10 text-xs font-medium tracking-widest uppercase backdrop-blur-md mb-4 text-white/80">
                        Who We Are
                    </span>
                    <EyebrowLarge>ABOUT IVANI</EyebrowLarge>
                </div>
                {/* </Reveal> */}

                <Reveal className="relative z-10">
                    <div className="glass-card p-6 md:p-12 rounded-[32px] md:rounded-[40px] grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-24 items-center relative overflow-hidden group">

                        {/* Decorative Grid Pattern Overlay */}
                        <div className="absolute inset-0 bg-[url('https://grainy-gradients.vercel.app/noise.svg')] opacity-20 pointer-events-none mix-blend-overlay"></div>

                        {/* Text Content */}
                        <div className="lg:col-span-7 relative z-10 order-2 lg:order-1">
                            <h3 className="font-heading text-3xl md:text-5xl font-bold text-white  md:mb-10 leading-[1.1]">

                            </h3>
                            <div className="space-y-6 md:space-y-8 text-zinc-300/90 text-base md:text-lg leading-relaxed font-light">
                                <p>
                                    IVANI was born from a simple belief - that every organization deserves the right solutions and the right partners to thrive. What started as an idea has grown into a mission: to bring together values and innovation, so that businesses don’t just solve problems, but build partnerships that truly last and create impact.
                                    For us, clarity, trust, and genuine human connection aren’t just words, they’re the foundation of everything we do. IVANI isn’t just a consultancy; we’re a team that walks alongside you, helping you make sense of complexity and move forward with confidence. Our strength lies in our people-  a diverse mix of experienced professionals and curious thinkers who see challenges from new angles.

                                    In a world that’s constantly changing, we act as a trusted connector and guide, opening doors to possibilities, enabling growth, and turning ambition into reality.
                                </p>
                            </div>

                            <div className="mt-8 md:mt-10 flex flex-wrap gap-3 md:gap-4">
                                <div className="flex items-center gap-3 px-4 py-2 md:px-5 md:py-3 rounded-2xl bg-white/5 border border-white/5 backdrop-blur-sm">
                                    <div className="h-8 w-8 rounded-full bg-green-500/20 flex items-center justify-center">
                                        <TrendingUp className="h-4 w-4 text-green-400" />
                                    </div>
                                    <span className="text-sm font-medium text-white">Result Oriented</span>
                                </div>
                                <div className="flex items-center gap-3 px-4 py-2 md:px-5 md:py-3 rounded-2xl bg-white/5 border border-white/5 backdrop-blur-sm">
                                    <div className="h-8 w-8 rounded-full bg-blue-500/20 flex items-center justify-center">
                                        <Heart className="h-4 w-4 text-blue-400" />
                                    </div>
                                    <span className="text-sm font-medium text-white">Human Centric</span>
                                </div>
                            </div>
                        </div>

                        {/* Image / Visuals */}
                        <div className="lg:col-span-5 relative z-10 order-1 lg:order-2 h-full min-h-[300px] md:min-h-[400px]">
                            <div className="relative h-full w-full rounded-[30px] overflow-hidden shadow-2xl ring-1 ring-white/10 transform transition-transform duration-700 hover:scale-[1.02]">
                                <img
                                    src={aboutImage}
                                    alt="About IVANI"
                                    className="h-full w-full object-cover"
                                />
                                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent pointer-events-none" />


                            </div>

                            {/* Decorative Floating Element behind */}
                            <div className="absolute -top-10 -right-10 w-32 h-32 rounded-full blur-[40px] opacity-20 bg-white animate-pulse"></div>
                        </div>
                    </div>
                </Reveal>
            </Container>
        </Section>
    );
}
